module.exports = __webpack_public_path__ + "static/media/tampa.85c523db.png";